import type { Tracker, TrackEvent } from './Tracker';

/** One backend's `send`, or its `track` and an immediate resolve when it has none. Never rejects. */
export function sendOne(tracker: Tracker, event: TrackEvent): Promise<void> {
  if (tracker.send) return tracker.send(event).catch(() => undefined);
  tracker.track(event);
  return Promise.resolve();
}
